"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.bindContext = exports.bindModel = exports.injectStore = exports.getFieldClass = exports.OtherTypeUnitId = exports.numberThresholdValue = void 0;
const text_field_1 = require("./text_field");
const attachment_field_1 = require("./attachment_field");
const date_time_field_1 = require("./date_time_field");
const created_time_field_1 = require("./created_time_field");
const last_modified_time_field_1 = require("./last_modified_time_field");
const number_field_1 = require("./number_field");
const currency_field_1 = require("./currency_field");
const percent_field_1 = require("./percent_field");
const auto_number_field_1 = require("./auto_number_field");
const select_field_1 = require("./select_field");
const link_field_1 = require("./link_field");
const url_field_1 = require("./url_field");
const virtual_field_1 = require("./virtual_field");
const field_types_1 = require("../../types/field_types");
const field_1 = require("./field");
const email_field_1 = require("./email_field");
const phone_field_1 = require("./phone_field");
const rating_field_1 = require("./rating_field");
const checkbox_field_1 = require("./checkbox_field");
const formula_field_1 = require("./formula_field");
const lookup_field_1 = require("./lookup_field");
const member_field_1 = require("./member_field");
const created_by_field_1 = require("./created_by_field");
const last_modified_by_field_1 = require("./last_modified_by_field");
const single_text_field_1 = require("./single_text_field");
const cascader_field_1 = require("./cascader_field");
__exportStar(require("./field"), exports);
__exportStar(require("./stat"), exports);
__exportStar(require("./text_field"), exports);
__exportStar(require("./number_field"), exports);
__exportStar(require("./select_field"), exports);
__exportStar(require("./date_time_field"), exports);
__exportStar(require("./virtual_field"), exports);
__exportStar(require("./attachment_field"), exports);
__exportStar(require("./link_field"), exports);
__exportStar(require("./url_field"), exports);
__exportStar(require("./email_field"), exports);
__exportStar(require("./phone_field"), exports);
__exportStar(require("./rating_field"), exports);
__exportStar(require("./member_field"), exports);
__exportStar(require("./formula_field"), exports);
__exportStar(require("./lookup_field"), exports);
__exportStar(require("./currency_field"), exports);
__exportStar(require("./single_text_field"), exports);
__exportStar(require("./created_time_field"), exports);
__exportStar(require("./last_modified_time_field"), exports);
__exportStar(require("./created_by_field"), exports);
__exportStar(require("./last_modified_by_field"), exports);
__exportStar(require("./text_base_field"), exports);
var number_base_field_1 = require("./number_base_field");
Object.defineProperty(exports, "numberThresholdValue", { enumerable: true, get: function () { return number_base_field_1.numberThresholdValue; } });
var member_base_field_1 = require("./member_base_field");
Object.defineProperty(exports, "OtherTypeUnitId", { enumerable: true, get: function () { return member_base_field_1.OtherTypeUnitId; } });
const getFieldClass = (type) => {
    switch (type) {
        case field_types_1.FieldType.Text: {
            return text_field_1.TextField;
        }
        case field_types_1.FieldType.Number: {
            return number_field_1.NumberField;
        }
        case field_types_1.FieldType.Currency: {
            return currency_field_1.CurrencyField;
        }
        case field_types_1.FieldType.Percent: {
            return percent_field_1.PercentField;
        }
        case field_types_1.FieldType.AutoNumber: {
            return auto_number_field_1.AutoNumberField;
        }
        case field_types_1.FieldType.SingleSelect: {
            return select_field_1.SingleSelectField;
        }
        case field_types_1.FieldType.MultiSelect: {
            return select_field_1.MultiSelectField;
        }
        case field_types_1.FieldType.DateTime: {
            return date_time_field_1.DateTimeField;
        }
        case field_types_1.FieldType.CreatedTime: {
            return created_time_field_1.CreatedTimeField;
        }
        case field_types_1.FieldType.LastModifiedTime: {
            return last_modified_time_field_1.LastModifiedTimeField;
        }
        case field_types_1.FieldType.Attachment: {
            return attachment_field_1.AttachmentField;
        }
        case field_types_1.FieldType.Link: {
            return link_field_1.LinkField;
        }
        case field_types_1.FieldType.URL: {
            return url_field_1.URLField;
        }
        case field_types_1.FieldType.Email: {
            return email_field_1.EmailField;
        }
        case field_types_1.FieldType.Phone: {
            return phone_field_1.PhoneField;
        }
        case field_types_1.FieldType.Rating: {
            return rating_field_1.RatingField;
        }
        case field_types_1.FieldType.Checkbox: {
            return checkbox_field_1.CheckboxField;
        }
        case field_types_1.FieldType.Member: {
            return member_field_1.MemberField;
        }
        case field_types_1.FieldType.CreatedBy: {
            return created_by_field_1.CreatedByField;
        }
        case field_types_1.FieldType.LastModifiedBy: {
            return last_modified_by_field_1.LastModifiedByField;
        }
        case field_types_1.FieldType.LookUp: {
            return lookup_field_1.LookUpField;
        }
        case field_types_1.FieldType.Formula: {
            return formula_field_1.FormulaField;
        }
        case field_types_1.FieldType.SingleText: {
            return single_text_field_1.SingleTextField;
        }
        case field_types_1.FieldType.Cascader: {
            return cascader_field_1.CascaderField;
        }
        case field_types_1.FieldType.DeniedField: {
            return virtual_field_1.DeniedField;
        }
        default: {
            return virtual_field_1.NotSupportField;
        }
    }
};
exports.getFieldClass = getFieldClass;
/**
 * Static store for injection to external callers (web-side).
 * Before calling Field on the web side, inject the store instance first, then you don't need to pass in the store again every time you bindModel
 */
let storeCache;
const injectStore = (store) => { storeCache = store; };
exports.injectStore = injectStore;
/**
 * Bind the field model data to get an instance of the field calculation method.
 * A cache is done here. Prevent unnecessary memory consumption caused by new instances when called frequently.
 */
exports.bindModel = (() => {
    const cache = {};
    return (field, inState, newInstance) => {
        if (!inState && !storeCache) {
            throw new Error('Please pass in the store data source');
        }
        const state = inState || storeCache.getState();
        // Force initialize a new instance
        if (newInstance) {
            const FieldClass = (0, exports.getFieldClass)(field.type);
            // @ts-ignore
            return new FieldClass(field, state);
        }
        if (cache[field.type]) {
            // When the instance already exists, you only need to modify the this.field property to meet the data initialization requirements.
            cache[field.type].field = field;
            cache[field.type].state = state;
            return cache[field.type];
        }
        const FieldClass = (0, exports.getFieldClass)(field.type);
        const fieldInstance = new FieldClass(field, state);
        cache[field.type] = fieldInstance;
        return fieldInstance;
    };
})();
const bindContext = (field, state) => {
    const FieldClass = (0, exports.getFieldClass)(field.type);
    return new FieldClass(field, state);
};
exports.bindContext = bindContext;
field_1.Field.bindModel = exports.bindModel;
// The difference between bindContext and bindModel is that 
// bindContext creates a new Field object every time, and it is mandatory to pass in the store.
field_1.Field.bindContext = exports.bindContext;
//# sourceMappingURL=index.js.map